"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutlookPopup = exports.OutlookPopupInstance = void 0;
const json_1 = require("@/app/shared/helpers/json");
const promise_1 = require("@/app/shared/helpers/promise");
class OutlookPopupInstance {
    constructor() {
        Object.defineProperty(this, "dialog", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    async open(url, options) {
        return (0, promise_1.waitForPromise)(new Promise((resolve) => {
            const screenWidth = window.screen.width;
            const screenHeight = window.screen.height;
            const widthPercent = Math.max(20, Math.min((options.width / screenWidth) * 100, 80));
            const heightPercent = Math.max(20, Math.min((options.height / screenHeight) * 100, 80));
            window?.Office?.context.ui.displayDialogAsync(url, { width: widthPercent, height: heightPercent, promptBeforeOpen: false }, (asyncResult) => {
                if (asyncResult.status === window?.Office?.AsyncResultStatus.Succeeded) {
                    this.dialog = asyncResult.value;
                    resolve(this.dialog);
                }
                else {
                    console.error('Failed to open popup:', asyncResult.error.message);
                }
            });
        }), 10000);
    }
    onMessage(callback) {
        if (!this.dialog) {
            throw new Error('Dialog is not open');
        }
        this.dialog.addEventHandler(window?.Office?.EventType.DialogMessageReceived, (arg) => {
            if ('message' in arg) {
                const message = (0, json_1.decode_json)(arg.message);
                if (message)
                    callback(message);
            }
        });
    }
    close() {
        if (this.dialog) {
            this.dialog.close();
        }
    }
}
exports.OutlookPopupInstance = OutlookPopupInstance;
exports.OutlookPopup = new OutlookPopupInstance();
